export default __webpack_public_path__ + "7c704d75c106e8b6a1b2a6dde972480e.gif";